import { ConfirmBookingsActionTypes, ConfirmBookingsState, CONFIRM_BOOKINGS_FAILURE, CONFIRM_BOOKINGS_REQUEST, CONFIRM_BOOKINGS_SUCCESS } from "./types";

const defaultState: ConfirmBookingsState = {
  isLoading: false,
  errorMessage: ""
};

export default function confirmBookings(state = defaultState, action: ConfirmBookingsActionTypes): ConfirmBookingsState {
  switch (action.type) {
    case CONFIRM_BOOKINGS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case CONFIRM_BOOKINGS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case CONFIRM_BOOKINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};